module.exports = __webpack_public_path__ + "img/product_127.48f6b4a.svg";